module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/menu/menu_help_feedback-ed680e.svg";